import React , { useState, useEffect } from "react";
import {Button, Col, Row} from "react-bootstrap";
import Modal from "react-responsive-modal";
import moment from "moment/moment";
import {SECURITY_SERVICE_NAME, GRAPHS_SERVICE_NAME, ADVANCE_GROUPING_SERVICE_NAME, HUMIDITY_SERVICE_NAME} from "../constants/Constants";


const strings = require('../resources/strings.json');

const SECURITY_SERVICE_LIST = [
    SECURITY_SERVICE_NAME.NONE,
    SECURITY_SERVICE_NAME.DIY,
    SECURITY_SERVICE_NAME.CONTEXTUAL
];

const GRAPHS_SERVICE_LIST = [
    GRAPHS_SERVICE_NAME.NONE,
    GRAPHS_SERVICE_NAME.AGGREGATED,
    GRAPHS_SERVICE_NAME.COMPLETE
];

const ADVANCE_GROUP_SERVICE_LIST= [
    ADVANCE_GROUPING_SERVICE_NAME.NONE,
    ADVANCE_GROUPING_SERVICE_NAME.BASIC,
    ADVANCE_GROUPING_SERVICE_NAME.ADVANCE
];

const HUMIDITY_SERVICE_LIST = [
    HUMIDITY_SERVICE_NAME.NONE,
    HUMIDITY_SERVICE_NAME.HUMIDITY
];


export default function SubscriptionModal(props) {

    const [service, setState] = useState({
        security: "",
        graphs: "",
        advanceGrouping: "",
        humidity: "",
        subscriptionEndDate: null
      });

    useEffect(() => {
        setState({ 
            security: props.user.security,
            graphs: props.user.graphs,
            advanceGrouping: props.user.advanceGrouping,
            humidity: props.user.humidity,
            subscriptionEndDate: props.user.subscriptionEndDate
        })
    }, [props]);
   
    const setSubscriptionEndDate = event => {
        setState({
        ...service,
        subscriptionEndDate: event.target.value
        });
    };

    const onSelectSecurity = event => {
        setState({
        ...service,
          security: event.target.value
        });
    };

    const onSelectGraph= event => {
        setState({
            ...service,
          graphs: event.target.value
        });
    };

    const onSelectAdvanceGroup = event => {
        setState({
            ...service,
          advanceGrouping: event.target.value
        });
    };

    const onSelectHumidity = event => {
        setState({
            ...service,
          humidity: event.target.value
        });
    };
      
    const currentDate =new Date().toUTCString();
    const minDateValue = moment.utc(currentDate).format("YYYY-MM-DD");
 
    return (
        <Modal open={props.show} onClose={props.onCloseClicked} centered style={{ margin: 30 }} >
            <h4 style={{width: "1000px"}}> Update subscription for user {props.user.userEmail} and premises {props.user.name} </h4>
            <Row style={{marginTop: 50}}>
                <Col sm={3} style={{marginLeft: 20}}> <h5> {strings.security} </h5></Col>
                <Col sm={4}>
                <select className="form-control" value={service.security} onChange={(value) => onSelectSecurity(value)}>
                        {
                            SECURITY_SERVICE_LIST.map((e, key) => {
                                return <option key={key} value={e}>{e}</option>;
                            })
                        }
                     </select>
                </Col>
            </Row>
            <Row style={{marginTop: 40}}>
                <Col  sm={3} style={{marginLeft: 20}}> <h5> {strings.graphs} </h5></Col>
                <Col  sm={4}>
                <select className="form-control" value={service.graphs}  onChange={(value) => onSelectGraph(value)}>
                        {
                            GRAPHS_SERVICE_LIST.map((e, key) => {
                                return <option key={key} value={e}>{e}</option>;
                            })
                        }
                    </select>
                </Col>
            </Row>
            <Row style={{marginTop: 40}}>
                <Col sm={3} style={{marginLeft: 20}}> <h5> {strings.advanceGrouping} </h5> </Col>
                <Col sm={4}>
                <select  className="form-control" value={service.advanceGrouping} onChange={(value) => onSelectAdvanceGroup(value)}>
                        {
                            ADVANCE_GROUP_SERVICE_LIST.map((e, key) => {
                                return <option key={key} value={e}>{e}</option>;
                            })
                        }
                    </select>
                </Col>
            </Row>
            <Row style={{marginTop: 40}}>
                <Col sm={3} style={{marginLeft: 20}}><h5> {strings.humidity} </h5></Col>
                <Col sm={4}>
                    <select  className="form-control" value={service.humidity} onChange={(value) => onSelectHumidity(value)}>
                        {
                            HUMIDITY_SERVICE_LIST.map((e, key) => {
                                return <option key={key} value={e}>{e}</option>;
                            })
                        }
                    </select>
                </Col>
            </Row>
            <Row style={{marginTop: 40}}>
            <Col sm={3} style={{marginLeft: 20}}><h5> {strings.subscriptionEndDate} </h5></Col>
                <Col sm={4}>  
                    <input className="form-control" type="date" name="subscriptonEndDate" id="subscriptonEndDate"
                    value={moment.utc(service.subscriptionEndDate).format("YYYY-MM-DD")} 
                    min={ minDateValue }
                    onChange={(event) => setSubscriptionEndDate(event)} />
                 </Col>
            </Row>
            <Row style={{marginTop: 40}}>
                <Button style={{marginLeft: 20}} onClick={() => {props.onUpdate(props.user, service)}} >{strings.submit}</Button>
            </Row>
        </Modal>
    )  
}